import React, { useState } from "react";
import { PiShoppingCartSimple } from "react-icons/pi";
import { useNavigate } from "react-router-dom";
import useAddToCart from "../hooks/useAddToCart";
import useUser from "../hooks/useUser";
import { saveIntendedRoute } from "../local_store/intendedRouteLocalStore";
import CustomSnackBar from "./CustomSnackBar";
import CustomThreeDotsSpinner from "./spinners/CustomThreeDotsSpinner";
import ViewAllButton from "./ViewAllButton";
import { useLocation } from "react-router-dom";
import classNames from "classnames";
import { getColorArray } from "../helpers/extractors";
import ColorCircle from "./ColorCircle";
import GeneralModal from "./GeneralModal";
import { useCart } from "../contexts/CartContext";

function AddToCartButton({ color, productId, quantity, chooseColor, maxSize = false, needsInstallation = false, addInstallationPrice = false, product }) {
  const [isAdding, setIsAdding] = useState(false);
  const [addInstallation, setAddInstallation] = useState(true);
  const { user } = useUser();
  const { addToUserCart } = useAddToCart();
  const { addToCart } = useCart();

  const location = useLocation();

  const [snackBarMessage, setSnackBarMessage] = useState("");
  const [openSnackBar, setOpenSnackBar] = useState(false);
  const [isError, setIsError] = useState(false);
  const [savedItemColor, setSavedItemColor] = useState(null)
  const [showColorModal, setShowColorModal] = useState(false)

  const details = {
    productId,
    color: chooseColor ? (color || savedItemColor) : "",
    quantity,
    userId: user?.id,
    accessToken: user?.accessToken,
    addInstallationPrice: addInstallationPrice || addInstallation,
  };

  // Add to cart
  const handleAddToCart = () => {
    if (quantity < 1) {
      setOpenSnackBar(true);
      setIsError(true);
      setSnackBarMessage("Please add quantity");
      return;
    }
    if (chooseColor && !color && !savedItemColor) {
      if (location.search === "?tab=saved-items") {
        setShowColorModal(true);
        return;
      } else {
        setOpenSnackBar(true);
        setIsError(true);
        setSnackBarMessage("Please select a color");
        return;
      }
    }
    setShowColorModal(false);

    if (user) {
      setIsAdding(true);
      addToUserCart(details)
        .then((res) => {
          setIsError(false);
          setSnackBarMessage("Successfully added to cart");
        })
        .catch((err) => {
          setIsError(true);
          setSnackBarMessage(err?.message);
        })
        .finally(() => {
          setOpenSnackBar(true);
          setIsAdding(false);
        });
    } else {
      // Add to local cart
      addToCart(product, quantity, savedItemColor || color, addInstallationPrice || addInstallation);
      setOpenSnackBar(true);
      setIsError(false);
      setSnackBarMessage("Successfully added to cart")
    }
  };

  const handleModalClose = () => {
    setSavedItemColor(null)
    setShowColorModal(false)
  }

  return (
    <>
      <div className={classNames(maxSize && "w-2/5 md:w-auto")}>
        <ViewAllButton
          text={isAdding ? "" : `Add to cart`}
          onClick={handleAddToCart}
          disabled={isAdding}
          className={classNames("border-orange-400 text-[#FF9D21] hover:text-white hover:bg-[#FF9D21] border max-md:!py-1", maxSize && "w-full")}
          icon={<PiShoppingCartSimple />}
        >
          {isAdding && (
            <CustomThreeDotsSpinner height="20" width="20" color="white" />
          )}
        </ViewAllButton>

        <CustomSnackBar
          isOpen={openSnackBar}
          onClose={() => setOpenSnackBar(false)}
          message={snackBarMessage}
          isError={isError}
        />
      </div>
      <GeneralModal
        isOpen={showColorModal}
        onClose={handleModalClose}
        showCloseButton={true}
        widthClass="w-[40%] max-lg:w-[60%] max-md:w-[90%]  p-4"
      >
        <div className="text-[14px] max-md:text-[12px] font-[600] mb-6">
          {savedItemColor}
          <p className="mb-3">Choose a Color </p>
          <div className="flex gap-1">
            {getColorArray(chooseColor).map((color, idx) => {
              return (
                <ColorCircle
                  key={idx}
                  colorHex={color}
                  getColor={setSavedItemColor}
                  selectedColor={savedItemColor}
                />
              );
            })}
          </div>
          {needsInstallation && (
            <div className="flex gap-1 items-center mt-3">
              <input
                type="checkbox"
                checked={addInstallation}
                onChange={(e) => setAddInstallation(e.target.checked)}
              />
              <p className="text-[16px] max-lg:text-[14px] max-md:text-[12px] font-[500] mr-3 text-[#101928]">
                Add installation fee
              </p>
            </div>
          )}
          <div className="flex items-center gap-4 mt-6">
            <button onClick={handleModalClose} className="rounded-full w-1/2 bg-gray-400 border border-gray-400 hover:bg-gray-500 hover:border-gray-500 text-white py-2 transition-all duration-300 ease-in-out">Cancel</button>
            <button onClick={handleAddToCart} disabled={!savedItemColor} className="rounded-full w-1/2 bg-orange-500 border border-orange-500 hover:bg-transparent hover:text-orange-500 text-white py-2 transition-all duration-300 ease-in-out disabled:cursor-not-allowed disabled:bg-orange-400 disabled:text-white/75">Continue</button>
          </div>
        </div>
      </GeneralModal>
    </>
  );
}

export default AddToCartButton;
